import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

export type ToastKind = 'success' | 'error' | 'info' | 'warning';

export type Toast = {
    id: number;
    kind: ToastKind;
    message: string;
    description?: string;
    /** Set while the exit animation plays, right before the toast is dropped. */
    leaving?: boolean;
};

// Same timings as the `sonner` toaster used by the dexcarga-2.0 reference.
const DEFAULT_DURATION_MS = 4000;
const EXIT_ANIMATION_MS = 200;

@Injectable({ providedIn: 'root' })
export class ToastService {

    #id = 0;
    readonly $toasts = new BehaviorSubject<Toast[]>([]);

    success (message: string, description?: string) { return this.show('success', message, description); }
    error   (message: string, description?: string) { return this.show('error', message, description); }
    info    (message: string, description?: string) { return this.show('info', message, description); }
    warning (message: string, description?: string) { return this.show('warning', message, description); }

    show (kind: ToastKind, message: string, description?: string, duration = DEFAULT_DURATION_MS) {
        const toast: Toast = { id: ++this.#id, kind, message, description };
        this.$toasts.next([...this.$toasts.value, toast]);
        setTimeout(() => this.dismiss(toast.id), duration);
        return toast.id;
    }

    dismiss (id: number) {
        const toast = this.$toasts.value.find(item => item.id === id);
        if (!toast || toast.leaving) return;

        this.$toasts.next(this.$toasts.value.map(item => item.id === id ? { ...item, leaving: true } : item));
        setTimeout(() => this.$toasts.next(this.$toasts.value.filter(item => item.id !== id)), EXIT_ANIMATION_MS);
    }

    clear () {
        this.$toasts.next([]);
    }
}
